<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Select a page') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <label for="page">{{ _('Page') }}</label><br />
            <v-select :options="pages" v-model="page" label="name" keys="['id', 'name']" :placeholder="_('Type to search pages')" :create-item="false">
              <template v-slot:no-options="{ searching }">
                <template v-if="searching">
                  {{ _('No results found.') }}
                </template>
                <template v-else>{{ _('Type to search pages') }}</template>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div style="height: 300px"></div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selectPage"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'

export default {
  props: ['selectedPages'],
  mixins: [constants],
  data () {
    return {
      page: null,
      pages: []
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey']),
    selectedPageIds () {
      return this.selectedPages.map(l => l.id)
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectPage () {
      this.$emit('selectPage', this.page)
    },
    async loadPages() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/pages.json?catalog=true&iSortingCols=1&iSortCol_0=2&sSortDir_0=asc&apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.pages = response.data.filter(page => {
        return this.selectedPageIds.indexOf(page.id) === -1 // Only list products that are not already added
      })
    }
  },
  mounted () {
    this.loadPages()
  }
}
</script>